<template>
  <ion-page>
    <ion-content fullscreen scroll-y="false">
      <ion-slides ref="slides" @ionSlideReachEnd="markWatchedAndAdvance()">
        <ion-slide>
          <header
            :style="{
              'background-image': `url(${require('./intro-1.jpg')})`
            }"
          ></header>
          <section>
            <h1>The Problem</h1>
            <h2>Missing The Moment</h2>
            <hr />
            <p>
              Stay Seated is a real solution to a problem every fan faces –
              leave the game for a bite to eat, or stay seated and skip the
              concessions.
            </p>
            <div class="ion-text-center">
              <ion-button
                fill="clear"
                color="dark"
                @click="next()"
                data-cy="slide-advance-1"
              >
                Next
                <ion-icon slot="end" name="arrow-forward"></ion-icon>
              </ion-button>
            </div>
          </section>
        </ion-slide>

        <ion-slide>
          <header
            :style="{
              'background-image': `url(${require('./intro-2.jpg')})`
            }"
          ></header>
          <section>
            <h1>The Solution</h1>
            <h2>Enjoy Yourself</h2>
            <hr />
            <p>
              Our app is a game-changer (pun intended). With Stay Seated, you
              don't have to leave the comfort of your seat or miss a minute of
              the big game to enjoy the stadium's offerings. Now, you can have
              your burger and eat it, too.
            </p>
            <div class="ion-text-center">
              <ion-button
                fill="clear"
                color="dark"
                @click="next()"
                data-cy="slide-advance-2"
              >
                Next
                <ion-icon slot="end" name="arrow-forward"></ion-icon>
              </ion-button>
            </div>
          </section>
        </ion-slide>

        <ion-slide>
          <header
            :style="{
              'background-image': `url(${require('./intro-3.jpg')})`
            }"
          ></header>
          <section>
            <h1>How it Works</h1>
            <h2>Why Stay Seated</h2>
            <hr />
            <p>1. Place your order on the app</p>
            <p>2. Concession receives order</p>
            <p>3. Runner delivers order</p>
            <p>4. You stay seated and enjoy</p>
            <div class="ion-text-center">
              <ion-button
                fill="clear"
                color="dark"
                @click="markWatchedAndAdvance()"
                data-cy="slide-advance-3"
              >
                Get Started
                <ion-icon slot="end" name="arrow-forward"></ion-icon>
              </ion-button>
            </div>
          </section>
        </ion-slide>
        <ion-slide>
          <loading-spinner></loading-spinner>
        </ion-slide>
      </ion-slides>
    </ion-content>
  </ion-page>
</template>

<script>
import { StorageService, StorageKeys } from "@/services/Storage";

export default {
  methods: {
    next() {
      this.$refs.slides.slideNext();
    },
    markWatchedAndAdvance() {
      StorageService.set(StorageKeys.HAS_SEEN_APP_INTRO, true);
      this.$router.push({ name: "Sign Up" });
    }
  }
};
</script>

<style lang="scss">
.swiper-slide {
  display: block;
}
ion-slide {
  header {
    height: 40vh;
    @media (max-height: 600px) {
      height: 20vh;
    }
    background-size: cover;
  }
  section {
    padding: 2rem;
    text-align: left;
  }
  hr {
    background-color: #000000;
    width: 3.4rem;
    margin: 1.4rem 0;
  }
  h1 {
    margin: 0;
    font-family: PlayfairDisplayBoldItalic, serif;
    font-size: 2.5rem;
  }
  h2 {
    margin: 0.2rem 0 0 0;
    font-size: 1rem;
    letter-spacing: 2px;
    font-family: RalewayMedium;
    text-transform: uppercase;
  }
}
</style>
